import React, { useEffect } from "react";
import Metatag from "../../components/Metatag/Metatag";

const ElectricalInstallation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Metatag
        title="Electrical Installation & DEWA Approval Services"
        description="Looking for a reliable DEWA approved contractor? We provide top-tier electrical installation and DEWA approvals for residential & commercial projects in Dubai."
        link="electricalinstallation"
      />
      <div>
        <div className="text-center items-center mb-10 mt-10">
          <h1 className="text-[34px] font-semibold text-[black]">
            Electrical <span className="text-[#ffb732] text-[38px]">Installation</span>
          </h1>
          <p className="mt-3 text-lg font-medium text-gray-700 px-4">
            Safe, Compliant & Professional Electrical Solutions by a DEWA Approved Contractor
          </p>
        </div>

        <div className="flex-col flex lg:flex-row gap-[19px] sm:gap-10 lg:justify-around sm:w-[85%] sm:mx-auto p-4 mb-20 relative">
          <div className="rounded-xl w-full border-t-[2px] border-[#cbcbcb] lg:p-10 p-5 bg-white" style={{ boxShadow: '0px 2px 25px #7c78754f' }}>
            <p className="text-[#090a0e] text-lg leading-loose mb-6 text-justify">
              At <strong>Megavolt Technical Services Co. LLC</strong>, we are a leading <strong>DEWA approved contractor</strong> providing complete electrical installation services across Dubai. From small retail fit-outs to massive commercial and industrial developments, our expert team of engineers ensures every connection, fixture, and system is installed to perfection. 
            </p>
            <p className="text-[#090a0e] text-lg leading-loose mb-6 text-justify">
              Navigating <strong>DEWA approvals</strong> can be a complex process, but working with a licensed <strong>DEWA approved contractor</strong> makes it seamless. Our electrical division is dedicated to maintaining high-quality workmanship, strict regulatory compliance, and cost-effective solutions for all our clients.
            </p>

            <h2 className="text-[#ffb732] text-3xl font-semibold mb-4 border-b-2 border-[#ffb732] inline-block pb-2">Our Electrical Installation Services</h2>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-800 list-inside font-medium mb-10">
              <li className="flex items-center space-x-2"><span className="text-[#ffb732] text-xl">✔</span> <span>HV & LV Network Design & Installation</span></li>
              <li className="flex items-center space-x-2"><span className="text-[#ffb732] text-xl">✔</span> <span>Complete Substation and LV Room Systems</span></li>
              <li className="flex items-center space-x-2"><span className="text-[#ffb732] text-xl">✔</span> <span>Earthing & Lightning Protection Systems</span></li>
              <li className="flex items-center space-x-2"><span className="text-[#ffb732] text-xl">✔</span> <span>Lighting & Power Layout Design</span></li>
              <li className="flex items-center space-x-2"><span className="text-[#ffb732] text-xl">✔</span> <span>BMS & Control System Integration</span></li>
              <li className="flex items-center space-x-2"><span className="text-[#ffb732] text-xl">✔</span> <span>Fast-Track DEWA Approval Services</span></li>
            </ul>

            <div className="bg-gray-50 border-l-4 border-[#ffb732] p-6 mb-10 text-[#090a0e]">
              <h3 className="font-bold text-2xl mb-3">Why DEWA Approval Matters</h3>
              <p className="mb-2">Securing <strong>DEWA approval</strong> is legally mandatory before initiating power and water services in Dubai. As your trusted <strong>DEWA approved contractor</strong>, we handle the entire process end-to-end—from submitting drawings and NOC applications to finalizing inspections and commissioning operations.</p>
            </div>

            <div className="mt-8 text-center bg-[#f9f9f9] border border-gray-300 p-8 rounded-lg shadow-inner">
              <h2 className="text-[#ffb732] text-3xl font-bold mb-4">Start Your Project Today</h2>
              <p className="text-[#090a0e] text-lg leading-loose mb-4 max-w-3xl mx-auto">
                Leave the heavy lifting and compliance checks to us. Get in touch with Megavolt Technical Services to secure fast <strong>DEWA approvals</strong> and superior electrical installation services.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ElectricalInstallation;
